import { adminDoGetLists } from "services/admin/list";
import { useStore } from "stores/store";

export const fetchLists = async () => {
  const lists = await adminDoGetLists();
  useStore.setState((state) => ({ ...state, lists }));
};
